// extracted by mini-css-extract-plugin
export var measureBox = "_1a-0";